<template>
    <div>
        <el-dialog
            title=""
            :visible.sync="dialogVisible"
            width="65%"
            :close-on-click-escape="false"
            :close-on-click-modal="false"
             @closed="onHidden"
            :before-close="onHidden"
            custom-class="loadingDivCreate"
            center>
            <h1 class="text-md-center" v-if="showResult">ยืนยันการ Create Shipment</h1>
            <div v-if="!showResult">
                <h1 class="text-md-center">Result Create Shipment</h1>
                <h6 class="text-md-center">orderNumber : {{detail.orderNumber}}</h6>
                <h6 class="text-md-center">trackingNumber : {{detail.trackingNumber}}</h6>
                <h6 class="text-md-center">courierProviderName : {{detail.courierProviderName}}</h6>
                <h6 class="text-md-center">errorCode : {{detail.errorCode}}</h6>
                <h6 class="text-md-center">errorMessage : {{detail.errorMessage}}</h6>
            </div>
             <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">ยกเลิก</el-button>
                <el-button type="primary" @click="createShipment" v-if="showResult">ยืนยัน</el-button>
            </span>
            </el-dialog>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'

export default {
    name: 'CreateShipment',
    props: {
        dialogShow: {
            type: Boolean,
            default: false
        },
        CrateShipmentDetail: {
            type: Object,
            default: null
        },
        createShipmentOrderId: {
            type: Number,
            default: 0
        }
    },
    data () {
        return {
            dialogVisible: false,
            detail: {},
            result: {},
            showResult: true
        }
    },
    watch: {
        dialogShow (val) {
            if (val) {
                // init data agian
                this.dialogVisible = true
            }
        },
        CrateShipmentDetail (val) {
            if (val) {
                this.detail = { ...val }
            }
        }
    },
    methods: {
        onHidden (done) {
            this.showResult = true
            this.result = {}
            this.$emit('closeModal')
            if (done !== undefined) {
                done()
            }
        },
        async createShipment () {
            let loadingAddUser = this.$loading({
                target: '.loadingDivCreate',
                text: 'กำลังบันทึก...'
            })
            try {
                const checkCourieAndTrackingNumber = this.detail.courierId === 6 && (this.detail.trackingNumber.slice(0, 2) === 'EA' || this.detail.trackingNumber.slice(0, 2) === 'EB')
                const findCreateShipment = this.detail.orderHistory.some(e => e.action === 'Create shipment' && e.success)
                if (checkCourieAndTrackingNumber && findCreateShipment) {
                    let res = {}
                    try {
                        let param = {
                            orderNumbers: this.detail.order_numbers,
                            shopId: this.detail.shop_id,
                            status: this.detail.status
                        }
                        res = await fgApi.order.updateShipment(param)
                    } catch (error) {
                        console.log(error)
                    }
                    try {
                        await fgApi.order.updateDeliveryCost(this.detail)
                    } catch (error) {
                        console.log(error)
                    }
                    this.showResult = false
                    this.detail = { ...res.result[0] }
                    this.$emit('closeRefresh', this.createShipmentOrderId)
                } else {
                    this.detail.adminEmail = this.$store.get('user/objUser').email
                    let res = await fgApi.order.createShipment(this.detail)
                    if (res.success) {
                        const checkJntAndErrorCode = res.result[0].courierProviderName === 'J&T' && res.result[0].errorCode === 'S10'
                        if (checkJntAndErrorCode) {
                            try {
                                let param = {
                                    orderNumbers: this.detail.order_numbers,
                                    shopId: this.detail.shop_id,
                                    status: this.detail.status
                                }
                                await fgApi.order.updateShipment(param)
                            } catch (error) {
                                console.log(error)
                            }
                        }
                        try {
                            await fgApi.order.updateDeliveryCost(this.detail)
                        } catch (error) {
                            console.log(error)
                        }
                        this.showResult = false
                        this.detail = { ...res.result[0] }
                        this.$emit('closeRefresh', this.createShipmentOrderId)
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'error'
                        })
                    }
                }
            } catch (error) {
                this.$message({
                    message: error,
                    type: 'error'
                })
            }
            // this.$emit('closeRefresh')
            loadingAddUser.close()
        }

    }
}
</script>

<style lang="scss" scoped>

</style>
